const POLICY_PATH = {
  INDEX: '/policy',
  POLICY_TERM: '/policy#terms',
  POLICY_REVENUE: '/policy#revenue',
  POLICY_PRIVACY: '/policy#privacy',
  POLICY_REGULATION: '/policy#regulation',
  POLICY_YOUTH: '/policy#youth',
};

const AUTH_PATH = {
  SIGN_IN: '/sign-in',
  SIGN_IN_WITH_PASSWORD: '/sign-in/password',
  PASSWORD_FORGOT: '/password-forgot',
};

export const PATH = {
  MAIN: '/',
  DASHBOARD: '/dashboard',
  /**
   * 별지기 MG 전용 화면 (#2182). 지금은 대시보드 안의 블록으로 노출하고 있어 라우트를 걸지 않았다.
   * 전용 페이지로 분리하기로 확정되면 이 상수에 라우트만 등록하면 된다 — 섹션 컴포넌트는 그대로 쓴다.
   */
  DASHBOARD_MG: '/dashboard/mg',
  POLICY: POLICY_PATH,
  AUTH: AUTH_PATH,
};
